var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77634 17.2521H7.81787V8.77929C7.81787 7.29047 9.03193 6.07642 10.5207 6.07642H15.7092V16.8304H14.7508V7.03488H10.5207C9.56228 7.03488 8.77634 7.81443 8.77634 8.77929V17.2585V17.2521Z",
    fill: "#C72035"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6772 17.2524H12.7188V24H13.6772V17.2524Z",
    fill: "#C72035"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8147 17.2524H9.8562V24H10.8147V17.2524Z",
    fill: "#C72035"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7669 5.1885C10.3355 5.1885 9.17261 4.02556 9.17261 2.59425C9.17261 1.16294 10.3355 0 11.7669 0C13.1982 0 14.3611 1.16294 14.3611 2.59425C14.3611 4.02556 13.1982 5.1885 11.7669 5.1885ZM11.7669 0.958466C10.8659 0.958466 10.1311 1.69329 10.1311 2.59425C10.1311 3.49521 10.8659 4.23003 11.7669 4.23003C12.6678 4.23003 13.4026 3.49521 13.4026 2.59425C13.4026 1.69329 12.6678 0.958466 11.7669 0.958466Z",
    fill: "#C72035"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3418 17.4889H21.3833V8.64548H17.5878C17.2811 8.64548 16.9808 8.73493 16.7316 8.90746L16.1948 8.11513C16.6102 7.83398 17.0894 7.68701 17.5878 7.68701H22.3418V17.4889Z",
    fill: "#C72035"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4951 17.8784H19.5366V23.9998H20.4951V17.8784Z",
    fill: "#C72035"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8945 17.8784H16.936V23.9998H17.8945V17.8784Z",
    fill: "#C72035"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7187 6.97129C17.396 6.97129 16.3225 5.8978 16.3225 4.57512C16.3225 3.25244 17.396 2.17896 18.7187 2.17896C20.0414 2.17896 21.1148 3.25244 21.1148 4.57512C21.1148 5.8978 20.0414 6.97129 18.7187 6.97129ZM18.7187 3.13103C17.9263 3.13103 17.281 3.7764 17.281 4.56873C17.281 5.36106 17.9263 6.00643 18.7187 6.00643C19.511 6.00643 20.1564 5.36106 20.1564 4.56873C20.1564 3.7764 19.511 3.13103 18.7187 3.13103Z",
    fill: "#C72035"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95847 17.8787H1V10.1854C1 8.81161 2.11821 7.68701 3.4984 7.68701H7.05751V8.64548H3.4984C2.64856 8.64548 1.95847 9.33557 1.95847 10.1854V17.8787Z",
    fill: "#C72035"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40573 17.8784H5.44727V23.9998H6.40573V17.8784Z",
    fill: "#C72035"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80515 17.8784H2.84668V23.9998H3.80515V17.8784Z",
    fill: "#C72035"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62297 6.97129C3.30029 6.97129 2.22681 5.8978 2.22681 4.57512C2.22681 3.25244 3.30029 2.17896 4.62297 2.17896C5.94566 2.17896 7.01914 3.25244 7.01914 4.57512C7.01914 5.8978 5.94566 6.97129 4.62297 6.97129ZM4.62297 3.13103C3.83064 3.13103 3.18527 3.7764 3.18527 4.56873C3.18527 5.36106 3.83064 6.00643 4.62297 6.00643C5.41531 6.00643 6.06067 5.36106 6.06067 4.56873C6.06067 3.7764 5.41531 3.13103 4.62297 3.13103Z",
    fill: "#C72035"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.604f6d56.svg";
export { ForwardRef as ReactComponent };